import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCheckmark2Medium"><Path d="M5 13.875L9.2 18L19 7" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCheckmark2Medium;
